<template>
  <div class="indexActivitySelect">
    <div class="title">请选择参观展览所在校区</div>

    <div class="content-wrap">
      <div class="content-list" v-for="(hall, index) in list" :key="index" @click="toDetial(hall.id)">
        <div class="left">
          <!-- 无图占位样式 -->
          <div v-if="!hall.imgPath" class="img-placeholder">
            <div class="placeholder-icon">
              <div class="icon-line"></div>
              <div class="icon-dot"></div>
            </div>
            <div class="placeholder-text">暂无图片</div>
          </div>
          <img v-else class="img fit-img" :src="hall.imgPath" alt />
        </div>
        <div class="right">
          <div class="content-title">{{ hall.name }}</div>
          <div class="remark">{{ hall.remark }}</div>
          <div class="content-item">
            <div class="label">展览：</div>
            <div class="value">
              <!-- 下级展会 -->
              <div class="content-son-list" v-for="(sonItem, sonI) in hallObjList[hall.id]" :key="sonI">
                <div class="content-son-list-item">{{sonI+1}}、 {{ sonItem.name }}</div>
              </div>

              <div class="empty" v-if="!(hallObjList[hall.id] && hallObjList[hall.id].length)">该校区暂无展览</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { findAllSchArea, getActivityList } from "@/libs/api";
import Moment from "moment";
export default {
  data () {
    return {
      loading: false,
      list: [],
      hallObjList: {},
    };
  },
  methods: {
    async fetchAllSchArea () {
      const res = await findAllSchArea();
      if (res.status) {
        this.list = res.data;
      } else {
        this.$alert("展览校区获取失败。请稍后再试", "提示", {
          confirmButtonText: "确定",
          callback: action => { }
        });
      }
    },
    getHalls: function () {
      getActivityList(this.formatTime(new Date())).then(data => {
        if (data.status) {
          this.halls = data.data;
          data.data.forEach(item => {
            if (this.hallObjList[item.schId]) {
              this.hallObjList[item.schId].push(item)
            } else {
              this.hallObjList[item.schId] = [item]
            }
          });
          this.fetchAllSchArea()
        } else {
          this.nothing = true;
          this.$alert("展厅获取失败。请稍后再试", "提示", {
            confirmButtonText: "确定",
            callback: action => { }
          });
        }
        this.loading = false;
      });
    },
    //格式化日期
    formatTime (date) {
      const year = date.getFullYear();
      const month =
        date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      const hour = date.getHours();
      return `${year}-${month}-${day}`;
    },
    toDetial (id) {
      this.$router.push({
        path: '/home/activityIndex',
        query: {
          id
        }
      })
    }
  },
  created () {
    this.getHalls();
    // this.fetchAllSchArea()
  },
};
</script>

<style lang="less" scoped>
.indexActivitySelect {
  .title {
    font-size: 24px;
    color: white;
    text-align: center;
  }

  .content-list {
    min-height: 16vh;
    margin-bottom: 4vh;
    display: flex;
    padding: 20px;
    background-color: rgba(26, 26, 26, 0.78);

    .left {
      flex: 1;

      .fit-img {
        width: 100%;
        height: 100%;
        height: 15vh;
        object-fit: cover;
      }

      // 添加无图占位样式
      .img-placeholder {
        width: 100%;
        height: 100%;
        min-height: 120px;
        background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          animation: shine 2s infinite;
        }

        .placeholder-icon {
          width: 48px;
          height: 48px;
          position: relative;
          margin-bottom: 12px;

          .icon-line {
            width: 100%;
            height: 32px;
            border: 2px solid #94a3b8;
            border-radius: 4px;
            position: relative;

            &::before {
              content: '';
              position: absolute;
              top: 8px;
              left: 8px;
              right: 8px;
              height: 2px;
              background-color: #94a3b8;
            }

            &::after {
              content: '';
              position: absolute;
              top: 16px;
              left: 8px;
              right: 8px;
              height: 2px;
              background-color: #94a3b8;
            }
          }

          .icon-dot {
            width: 12px;
            height: 12px;
            background-color: #94a3b8;
            border-radius: 50%;
            position: absolute;
            bottom: 0;
            right: 0;
            border: 2px solid #f8fafc;
          }
        }

        .placeholder-text {
          color: #64748b;
          font-size: 14px;
          font-weight: 500;
        }
      }

      @keyframes shine {
        0% {
          transform: translateX(-100%);
        }
        100% {
          transform: translateX(100%);
        }
      }
    }

    .right {
      flex: 3;
      padding-left: 20px;
      color: white;

      .content-title {
        font-size: 30px;
      }

      .remark {
        margin-top: 10px;
        font-size: 14px;
        opacity: 0.8;
      }

      .content-item {
        display: flex;
        margin-top: 10px;
        font-size: 16px;

        .label {
          width: 50px;
          opacity: 0.8;
        }

        .value {
          flex: 1;
          opacity: 0.9;

          .empty {
            color: #7f7f7f;
          }
        }
      }

      .content-son-list {
        .content-son-list-item {
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>

<style scoped>
.activityContent::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 2px;
  background-color: #22222261;
}
.activityContent::-webkit-scrollbar-button {
  /*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*/
  /*background: #74d334;*/
  display: none;
}
.activityContent::-webkit-scrollbar-track {
  /*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  /*background: #ff66d5;*/
  display: none;
}
.activityContent::-webkit-scrollbar-track-piece {
  /*内层轨道，滚动条中间部分（位置4）*/
  /*background: #ff66d5;*/
}
.activityContent::-webkit-scrollbar-thumb {
  /*滚动条里面可以拖动的那部分（位置5）*/
  background: #ae0c2a;
  border-radius: 15px;
  width: 0.1px;
}
.activityContent::-webkit-scrollbar-corner {
  /*边角（位置6）*/
  background: #82afff;
}
.activityContent::-webkit-scrollbar-resizer {
  /*定义右下角拖动块的样式（位置7）*/
  background: #ff0bee;
}
.activityContent {
  scrollbar-arrow-color: #f4ae21; /**/ /*三角箭头的颜色*/
  scrollbar-face-color: #333; /**/ /*立体滚动条的颜色*/
  scrollbar-3dlight-color: #666; /**/ /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #666; /**/ /*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #999; /**/ /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666; /**/ /*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #666; /**/ /*立体滚动条背景颜色*/
  scrollbar-base-color: #f8f8f8; /**/ /*滚动条的基本颜色*/
}
.searchItem .el-input .el-input__inner {
  height: 35px;
}
.tag-wrap {
  color: rgb(174, 12, 42);
  border: 1px solid rgb(174, 12, 42);
  padding: 1px 3px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/single/activitySelect.vue